import { handleActions } from 'redux-actions'
import * as type from './type'
import { changeTableSettings, createInitialTableState } from '../../form/state/table-state-helper'
import { changeInList } from '../../../util/reducer-helper'


export const initialState = {
    leadList: [],
    fetching: false,
    error: null,
    lead: null,
    hasChanged: false,
    ...createInitialTableState(),
}


export default handleActions({
    [type.CHANGE_TABLE_SETTING]: changeTableSettings(),
    [type.FIND_ALL_LEAD_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_ALL_LEAD_SUCCESS]: (state, action) => {
        const { leadList } = action.payload
        return {
            ...state,
            leadList,
            fetching: false,
        }
    },
    [type.FIND_ALL_LEAD_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.FIND_LEAD_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            lead: null,
        }
    },
    [type.FIND_LEAD_SUCCESS]: (state, action) => {
        const { lead } = action.payload
        return {
            ...state,
            lead,
            fetching: false,
        }
    },
    [type.FIND_LEAD_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_LEAD]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            lead: {
                ...state.lead,
                [name]: value,
            },
            hasChanged: true,
        }
    },
    [type.SAVE_LEAD_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_LEAD_SUCCESS]: (state, action) => {
        const { lead } = action.payload
        return {
            ...state,
            lead,
            fetching: false,
            hasChanged: false,
            leadList: changeInList(state.leadList, lead),
        }
    },
    [type.SAVE_LEAD_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.ADD_SENT_EMAIL]: (state, action) => {
        const { sentEmail } = action.payload
        return {
            ...state,
            lead: {
                ...state.lead,
                sentEmailList: [
                    ...state.lead.sentEmailList,
                    sentEmail,
                ],
            },

        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/lead/state/reducer.js